module.exports = __webpack_public_path__ + "img/placeholder.c29dcfc7.svg";